import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const IPVACalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [vehicleValue, setVehicleValue] = useState('50.000,00');
  const [rate, setRate] = useState('4,00');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const v = parseFloat(parseBrazilianNumber(vehicleValue)) || 0;
    const r = parseFloat(parseBrazilianNumber(rate)) / 100;
    if (v <= 0 || r < 0) return;
    const ipva = v * r;
    const res = { ipva, v };
    setResultState(res);

    onResultChange([
      { label: 'Valor do Veículo', value: `R$ ${v.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Alíquota IPVA', value: `${(r * 100).toFixed(1)}%` },
      { label: 'Valor do IPVA', value: `R$ ${ipva.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <FormField label="Valor do Veículo (Tabela Fipe)" placeholder="R$ 0,00" value={vehicleValue} onChange={setVehicleValue} required isNumeric type="text" />
          <FormField label="Alíquota (%)" value={rate} onChange={setRate} required isNumeric type="text" helpText="Ex.: 4% em SP/RJ" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular IPVA
          </button>
        </div>

        {resultState && (
          <ResultCard
            title="Valor do IPVA"
            value={`R$ ${resultState.ipva.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`}
            description="Estimativa anual"
            color="indigo"
          />
        )}
      </div>

      <EducationalBlock
        title="Sobre o IPVA"
        tips={[
          'A alíquota varia conforme o estado e o tipo de veículo',
          'Geralmente, carros de passeio pagam entre 2% e 4% do valor venal',
          'A base de cálculo costuma ser o valor da Tabela FIPE de setembro do ano anterior',
          'O pagamento pode ser à vista com desconto ou parcelado'
        ]}
      />
    </div>
  );
};

export default IPVACalculator;
